<template>
  <modal visible>
    <div class="popup">
      <div class="popup-content">
        <slot />
      </div>
      <div class="popup-footer">
        <button v-if="showCancel" class="popup-btn" @click="cancel()">
          {{ cancelButtonText }}
        </button>
        <button class="popup-btn" @click="confirm()">
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../modal'

export default {
  components: {
    Modal
  },

  props: {
    showCancel: Boolean,
    confirmButtonText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: true
    },
    onConfirm: {
      type: Function,
      required: false
    }
  },

  methods: {
    confirm() {
      this.$emit('confirm')
    },

    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="sass" scoped>
.popup
  position: absolute
  width: 540px

  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  background-color: #fff
  border-radius: 8px
  overflow: hidden
  z-index: 5

  &-content
    padding: 48px

  &-footer
    display: flex
    align-items: center
    height: 90px
    justify-content: center
    border-top: 1px solid rgb(236, 236, 240)

  &-btn
    display: block
    width: 100%
    height: 100%
    line-height: 32px
    border: none
    border-right: 1px solid rgb(236, 236, 240)
    border-radius: 0
    background-color: #fff
    color: rgb(127, 127, 142)
    font-size: 32px
    font-family: PingFangSC-Regular
    font-weight: normal
    text-align: center
    line-height: 42px

    &:last-child
      border-right: none
      color: rgb(22, 165, 175)
      font-family: PingFangSC-Semibold
      font-weight: 600
      text-align: center

    &:focus
      outline: none
</style>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .popup {
    width: 540px;
    .popup-content {
      padding: 48px;
    }
    .popup-footer {
      height: 70px;
    }
    .popup-btn {
      line-height: 32px;
      font-size: 32px;
    }
  }
}
</style>
